import { Split } from './Splitter';

export default Split;
